// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_Q0DDQ","secondaryColumnCell":"secondary-column-cell_Q0DDQ","name":"name_brfMU"};